import { render, staticRenderFns } from "./foodExpenseDetailCompany.vue?vue&type=template&id=125d8976&scoped=true&"
import script from "./foodExpenseDetailCompany.vue?vue&type=script&lang=js&"
export * from "./foodExpenseDetailCompany.vue?vue&type=script&lang=js&"
import style0 from "./foodExpenseDetailCompany.vue?vue&type=style&index=0&id=125d8976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d8976",
  null
  
)

export default component.exports